import type { PaymentMethodId, ShippingMethodId } from "@/constants/enums";
import type { BillingAddress, ShippingAddress } from "@/types/common";
import type { OrderStatus } from "@/types/order";

export interface OrderData {
  order_id: number;
  status: OrderStatus;
  order_key: string;
  order_number: string;
  customer_note: string;
  customer_id: number;
  billing_address: BillingAddress;
  shipping_address: ShippingAddress;
  payment_method: PaymentMethodId;
  payment_result: PaymentResult;
  additional_fields: Record<string, any>; // 空物件，使用泛型表示
  __experimentalCart: any | null; // 為 null，但未來可能為物件
  extensions: Record<string, any>; // 空物件，使用泛型表示
}

export interface PaymentResult {
  payment_status: string;
  payment_details: any[]; // 根據資料是空陣列，若有更明確型別可再細化
  redirect_url: string;
}

export enum CheckoutReturnAction {
  CVS_STORE_SELECTION = "cvs_store_selection",
}

export enum CheckoutReturnActionStatus {
  SUCCESS = "success",
  ERROR = "error",
}

export interface CVSStore {
  CVSStoreID: string;
  CVSStoreName: string;
  CVSAddress: string;
}

export interface ShippingAddressForCVS {
  first_name: string;
  last_name: string;
  country: "TW";
  phone: string;
}

export interface BillingAddressForCVS extends ShippingAddressForCVS {
  email: string;
}

export interface ExtraOrderFields {
  shipping_method_id: ShippingMethodId;
  total_amount: string;
}

export interface CVSShippingFields {
  receiver_name: string;
  receiver_cellphone: string;
  receiver_email: string;
  receiver_store_id: string;
  receiver_store_name: string;
  receiver_store_address: string;
}
